// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__HeAxz","outline":"button_outline__H90Qc","disabled":"button_disabled__DzmNf"};